/** Merge top-level namespaces into a single translation object (CRA-friendly). */
export default function shallowMergeNamespaces(base, ...parts) {
  return parts.reduce((acc, p) => ({ ...acc, ...p }), { ...base });
}
